require('./favoritesCarouselController');

angular.module('app.shared.favoritesCarousel.favoritesCarouselDirective', [
  'app.shared.favoritesCarousel.favoritesCarouselController'
])
  .directive('favoritesCarousel', [
    '$window',
    function ($window) {
      "use strict";

      return {
        restrict: 'E',
        templateUrl: 'components/shared/favoritesCarousel/favoritesCarouselView.html',
        controller: 'app.shared.favoritesCarousel.favoritesCarouselController',
        scope: {
          allGamesIcon: '@'
        },
        link: (scope, element) => {
          let widthChanged = () => {
            if (!element.hasClass('ng-hide')) {
              let width = element.width();

              if (width > 1190) {
                scope.favoritesPerSlide = 10;
              }
              else if (width > 1070) {
                scope.favoritesPerSlide = 9;
              }
              else if (width > 950) {
                scope.favoritesPerSlide = 8;
              }
              else if (width > 830) {
                scope.favoritesPerSlide = 7;
              }
              else if (width > 730) {
                scope.favoritesPerSlide = 6;
              }
              else if (width > 650) {
                scope.favoritesPerSlide = 5;
              }
              else if (width > 530) {
                scope.favoritesPerSlide = 4;
              }
              else if (width > 410) {
                scope.favoritesPerSlide = 3;
              }
              else {
                scope.favoritesPerSlide = 2;
              }
            }
          };

          angular.element($window).bind('resize', () => {
            scope.$applyAsync(() => {
              widthChanged();
            });
          });

          widthChanged();
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/favoritesCarousel/favoritesCarouselDirective.js